/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { HexPermissionSummaryFragmentDoc } from "../hex/HexPermissionSummary.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type HexIsSharedFragment = {
  readonly __typename: "Hex";
  readonly id: c.HexId;
  readonly isShared: boolean;
};

export type SubNavigationBarActionsHexFragment = {
  readonly __typename: "Hex";
  readonly id: c.HexId;
  readonly isShared: boolean;
  readonly publicRoleV2: Types.ProjectRole | null;
  readonly organizationRoleV2: Types.ProjectRole | null;
  readonly grantSummary: c.ProjectGrantSummary;
  readonly onlyGrantedToCurrentUser: boolean;
  readonly owner: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly name: string | null;
    readonly email: string;
  };
  readonly lastPublishedVersion: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
  } | null;
  readonly org: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly displayName: string;
    readonly allowPublicSharing: boolean;
    readonly resolvedAllowPublicSharing: boolean;
  };
};

export type CreateReviewRequestSubNavMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type CreateReviewRequestSubNavMutation = {
  readonly __typename: "Mutation";
  readonly createPublishReviewRequest: {
    readonly __typename: "ReviewRequest";
    readonly id: c.ReviewRequestId;
  };
};

export type HexIsSharedUpdateSubscriptionVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type HexIsSharedUpdateSubscription = {
  readonly __typename: "Subscription";
  readonly hexRefresh: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly isShared: boolean;
  };
};

export const HexIsSharedFragmentDoc = /*#__PURE__*/ gql`
  fragment HexIsSharedFragment on Hex {
    id
    isShared
  }
`;
export const SubNavigationBarActionsHexFragmentDoc = /*#__PURE__*/ gql`
  fragment SubNavigationBarActionsHexFragment on Hex {
    id
    owner {
      id
      name
      email
    }
    ...HexIsSharedFragment
    ...HexPermissionSummaryFragment
    lastPublishedVersion {
      id
    }
  }
  ${HexIsSharedFragmentDoc}
  ${HexPermissionSummaryFragmentDoc}
`;
export const CreateReviewRequestSubNavDocument = /*#__PURE__*/ gql`
  mutation CreateReviewRequestSubNav($hexId: HexId!) {
    createPublishReviewRequest(hexId: $hexId) {
      id
    }
  }
`;
export type CreateReviewRequestSubNavMutationFn = Apollo.MutationFunction<
  CreateReviewRequestSubNavMutation,
  CreateReviewRequestSubNavMutationVariables
>;

/**
 * __useCreateReviewRequestSubNavMutation__
 *
 * To run a mutation, you first call `useCreateReviewRequestSubNavMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewRequestSubNavMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewRequestSubNavMutation, { data, loading, error }] = useCreateReviewRequestSubNavMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useCreateReviewRequestSubNavMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReviewRequestSubNavMutation,
    CreateReviewRequestSubNavMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReviewRequestSubNavMutation,
    CreateReviewRequestSubNavMutationVariables
  >(CreateReviewRequestSubNavDocument, options);
}
export type CreateReviewRequestSubNavMutationHookResult = ReturnType<
  typeof useCreateReviewRequestSubNavMutation
>;
export type CreateReviewRequestSubNavMutationResult =
  Apollo.MutationResult<CreateReviewRequestSubNavMutation>;
export type CreateReviewRequestSubNavMutationOptions =
  Apollo.BaseMutationOptions<
    CreateReviewRequestSubNavMutation,
    CreateReviewRequestSubNavMutationVariables
  >;
export const HexIsSharedUpdateDocument = /*#__PURE__*/ gql`
  subscription HexIsSharedUpdate($hexId: HexId!) {
    hexRefresh(hexId: $hexId) {
      id
      ...HexIsSharedFragment
    }
  }
  ${HexIsSharedFragmentDoc}
`;

/**
 * __useHexIsSharedUpdateSubscription__
 *
 * To run a query within a React component, call `useHexIsSharedUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHexIsSharedUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHexIsSharedUpdateSubscription({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useHexIsSharedUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    HexIsSharedUpdateSubscription,
    HexIsSharedUpdateSubscriptionVariables
  > &
    (
      | { variables: HexIsSharedUpdateSubscriptionVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    HexIsSharedUpdateSubscription,
    HexIsSharedUpdateSubscriptionVariables
  >(HexIsSharedUpdateDocument, options);
}
export type HexIsSharedUpdateSubscriptionHookResult = ReturnType<
  typeof useHexIsSharedUpdateSubscription
>;
export type HexIsSharedUpdateSubscriptionResult =
  Apollo.SubscriptionResult<HexIsSharedUpdateSubscription>;
